import './ShowpostallDetails.css';
let ShowpostallDetails=(props)=>{
    return(
        <div className='popupdivv'>
            <p className='vacancydetptag'>Short Details About Vacancy </p>
            <table className='toptable' style={{width:"100%"}}>
                
                <thead>
                    <tr>
                        {
                            props.latestdet[0]?.jobtitle !== undefined ? <th colSpan='2'>{props.latestdet[0].jobtitle} </th> : window.location="/search-jobs.com"
                        }
                        
                    </tr>
                    <tr className='twotabletr'> 
                        <td>
                            
                            <table className='importnttable'>
                                <thead>
                                <tr>
                                    <th colSpan='2'> Important Dates </th>
                                </tr>
                                <tr>
                                    <td>Application Begains : </td>
                                    <td>{props.latestdet[0].applicationpostdate}</td>
                                </tr>
                                <tr>
                                <td>Last Date Apply Online:</td>
                                    <td>{props.latestdet[0].lastapplyonlinedate}</td>
                                </tr>
                                <tr> 
                                <td>Pay Examination Fee Last Date:</td>
                                    <td>{props.latestdet[0].lastdateexaminationfee}</td>
                                </tr>
                                <tr>
                                <td>Correction Date :</td>
                                    <td>{props.latestdet[0].correctiondate}</td>
                                </tr>
                                <tr>
                                <td>Examination Date :</td>
                                    <td>{props.latestdet[0].examinationdate}</td>
                                </tr>
                                <tr>
                                <td>Exam city Avaliable date :</td>

                                    <td>{props.latestdet[0].examcitynotifydate}</td>
                                </tr>
                                <tr>
                                <td>Admit Card Avaliable Date :</td>

                                    <td>{props.latestdet[0].admitcardavailabledate}</td>
                                </tr>
                                <tr>
                                <td>Answer Key Avaliable Date :</td>
                                    <td>{props.latestdet[0].answerkeyavailabledate
                                        }</td>
                                </tr>
                                </thead>
                            </table>

                        </td>
                        <td>
                                
                            <table className='applicationfeetable'>
                                <thead>
                                    <tr>
                                        <th colSpan='2'> Application fee  </th>
                                    </tr>
                                    <tr>
                                        <td>For General</td>
                                        <td>{props.latestdet[0].general}</td>
                                    </tr>
                                    <tr>
                                        <td>Sc/St</td>
                                        <td>{props.latestdet[0].scst}</td>
                                    </tr>
                                    <tr>
                                        <td>Fee For All Female Candidate</td>
                                        <td>{props.latestdet[0].allfemalecandidate}</td>
                                    </tr>
                                    <tr>
                                    <td>Pay Via</td>

                                        <td>{props.latestdet[0].payvia}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th colSpan='2'>Documents Required</th>
                                    </tr>
                                    <tr>
                                        <td colSpan='2'>{
                                            props.latestdet[1] === '' ? <li>Not Avaliable</li> : props.latestdet[1]?.map(
                                                dfd=>(
                                                    <p style={{padding:"0 20px", margin:"0"}}>

                                                    <li style={{textAlign:"left"}}>{dfd?.documents}</li>       
                                                    </p>
                                                )
                                            ) 
                                            }
                                        </td>
                                        
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan='2'>

                            
                            <table className='agelimittable' style={{width:"100%"}}>
                                <thead>
                                    <tr>
                                        <th colSpan='2'>Age Limit</th>
                                    </tr>
                                    <tr>
                                        <td>Minimum Age</td>
                                        <td>{props.latestdet[0].minimumage}</td>
                                    </tr>
                                    <tr>
                                        <td>Maximum Age</td>
                                        <td>{props.latestdet[0].maximumage}</td>
                                    </tr>
                                    <tr>
                                    <td>Age Relaxaction as per</td>
                                        <td>{props.latestdet[0].jobtitle}</td>
                                        
                                    </tr>
                                </thead>
                            </table>
                        </td>
                    </tr>
                </thead>
            </table>
            {
            props.latestdet[2] === '' ? "" :
            <table className='totalposttable'>
                <caption className='postwistmainhead' colSpan='3'>{props.latestdet[0].jobtitle}--Total Posts:-{props.latestdet[0].totalpost}, Post wise Details</caption>
                <thead>
                    <tr>
                        <th>Post Name</th>
                        <th>Total Posts</th>
                        <th> Post vise Documents Required</th>
                    </tr>
                    {
                        props.latestdet[2]?.map(
                            oo=>(
                                <tr className='newtr'>
                                    <td>{oo.postname}</td>
                                    <td>{oo.totalposts}</td>
                                    <td>
                                    {
                                        props.latestdet[3].map(
                                        aa=>(
                                            oo.multipostid === aa.multipostid ?  <p>{aa.multiplepostdocrequired} </p>
                                                
                                            : ""
                                        )
                                        
                                        )
                                    }
                                    </td>
                                    
                                    
                                </tr>
                            )
                        )
                    }

                    
                </thead>
            </table> 
            }
            <table className='implonks' style={{width:"100%"}}>
            <thead>
                <tr>
                    <th colSpan='2'>Important Links</th>
                </tr>
                <tr>
                    <td>Apply Online</td>
                    <td>

                        {
                                
                        props.latestdet[0].applyonlinelink !== "na" ? <a href={props.latestdet[0].applyonlinelink}>Apply Now</a> : "Link Will Active Soon..!!!"
                    
                        }
                        {/* <a href={props.latestdet[0].applyonlinelink} target='_blank'>Apply Online</a> */}
                    
                        
                    </td>
                </tr>
                <tr>
                    <td>How to Online</td>
                    <td><a href={props.latestdet[0].howtoonlinevideolink} target='_blank' rel='noreferrer'>View Video</a></td>
                </tr>
                {/* <tr>
                    <td>Download Admit Card</td>
                    <td> <a href={props.latestdet[0].admitcarddownloadlink} target='_blank'>Download</a></td>
                </tr> */}
                <tr>
                    <td>Official Website</td>
                    <td><a href={props.latestdet[0].officialwebsitelink} target='_blank'  rel='noreferrer'>Click</a></td>
                </tr>
            </thead>
            </table>
        </div>
    );
}
export default ShowpostallDetails;